import { createValidator, required } from '@widgets/validation'
import { FileReviewModel } from './file-review.model'

export const fileReviewValidator = createValidator<FileReviewModel>({}, (values, errors) => {
  errors.arquivoValido = required(values.arquivoValido)

  if (values.arquivoValido === false) {
    errors.arquivoParecer = required(values.arquivoParecer)
  }

  return errors
})
